import { navigate } from 'gatsby'
import Text from 'components/Text'
import Button from 'components/Button'
import './LandingExpress.scss'
import { handlePerformanceMark } from 'utils/trackings/newRelicEvents'
import * as ROUTES from 'Routes'

const LandingExpress = ({ blok }) => {
  return (
    <div className="landing-express-container-express" id="BoletoExpress">
      <div className="content-express">
        <div className="description-express">
          <Text h2 size={1} className="label-text-express">
            {blok.Title} <span>{blok.boldText}</span>
          </Text>

          <Text p size={1} className="main-text-express">
            {blok.subTitle}
          </Text>

          <Button
            onClick={() => {
              handlePerformanceMark(ROUTES.register.pageName)
              navigate('/registro', {
                state: {
                  title:
                    'Para consultar seus acordos vigentes, precisamos das seguintes informações:',
                },
              })
            }}
            className="button_express"
            role="button"
            data-make-location="lp"
            data-make-position="lp-cta"
            data-make-actionoutcome="redirect"
            data-make-element="button"
            data-make-outboundurl={blok.linkButton}
          >
            {blok.buttonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LandingExpress
